import React from 'react';
import { withSiteMap, siteMapPropType, findSelectedNode } from '@bingads-webui-campaign-react/with-site-map';
import { ProgressiveLoadingBlock } from '@bingads-webui-campaign-react/shell-ui-common';
import { FallbackPage } from './fallback-page';

function isSelectedPageAvailable(siteMap) {
  const selectedNode = findSelectedNode(siteMap);

  return {
    needPlaceholder: !selectedNode,
    isAvailable: !!(selectedNode && selectedNode.selected && selectedNode.available),
  };
}

export function withFallbackPage(Component) {
  const Wrapper = (props) => {
    const { needPlaceholder, isAvailable } = isSelectedPageAvailable(props.siteMap);

    // FallbackUpdaterWithDefaultLandingPage will redirect to next available page.
    // Showing this ProgressiveLoadingBlock as we will finally launch to an available page.
    if (needPlaceholder) {
      return (<ProgressiveLoadingBlock />);
    }

    if (isAvailable) {
      return (<Component {...props} />);
    }

    return (<FallbackPage {...props} />);
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
  };

  return withSiteMap(Wrapper);
}
